import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  title,
  paragraph,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: title || 'Core Industries on Demand',
    paragraph: paragraph || 'We are associated with commercial enterprises across medically oriented, industrial, and technical environments, enabling patient care, emergency response, diagnostics, and technical services globally.'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image src={require('./../../assets/images/feature-tile-icon-01.svg')} alt="Hospitals" width={64} height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">Hospitals & Acute Care</h4>
                  <p className="m-0 text-sm" align="justify">
                      Equipment for clinical environments including stretchers, backboards, suction units, UV lights, wheelchair scales, ring-removal kits, and entrance mats.
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image src={require('./../../assets/images/feature-tile-icon-02.svg')} alt="EMS" width={64} height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">Ambulance & EMS</h4>
                  <p className="m-0 text-sm" align="justify">
                      Pre‑hospital care equipment such as Ferno scoop stretchers, KEDs, head immobilizers, traction splints, perfusion medic backpacks, and restraints.
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image src={require('./../../assets/images/feature-tile-icon-03.svg')} alt="Clinics" width={64} height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">Clinics & Outpatient</h4>
                  <p className="m-0 text-sm" align="justify">
                      Diagnostic systems, ear irrigators, cuff sets, Tono‑Pen/Tono‑Vera tonometers, digital acuity systems, pediatric supports, and chin straps.
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="0">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image src={require('./../../assets/images/feature-tile-icon-04.svg')} alt="Laboratories" width={64} height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">Laboratories & Diagnostics</h4>
                  <p className="m-0 text-sm" align="justify">
                      Support materials such as chemoblock gloves, laboratory labels, calibration syringes, radiometers, thermal print paper, and fluke kits.
                  </p>
                </div>
              </div>
            </div>

             <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image src={require('./../../assets/images/feature-tile-icon-05.svg')} alt="Industrial Safety" width={64} height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">Industrial & Safety</h4>
                  <p className="m-0 text-sm" align="justify">
                      Occupational health solutions including anemometer/weather trackers, entrance mats, protective tapes, gauss, and medical-grade skin protectants.
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image src={require('./../../assets/images/feature-tile-icon-06.svg')} alt="Utilities" width={64} height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">Utilities & Metering</h4>
                  <p className="m-0 text-sm" align="justify">
                     Supplying technical infrastructure components like Itron flow and water meters, and specialized accessories for large scale deployments.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;
